import {keyBy} from 'lodash-es';

import * as types from './../constants/assignmentActionTypes';

const initialState = {
  assignments: {
    dateRequested: null,
    dateLoaded: null,
    isLoading: false,
    items: {},
  },
};

function assignments(state = initialState.assignments, action) {
  switch (action.type) {
    case types.ASSIGNMENTS_LOAD_REQUEST:
      return {
        ...state,
        dateRequested: Date.now(),
        isLoading: !action.isPolling,
        dateLoaded: null
      };

    case types.ASSIGNMENTS_LOAD_SUCCESS:
      return {
        ...state,
        dateLoaded: Date.now(),
        isLoading: false,
        items: {
          ...action.assignments[0],
          ...keyBy(action.assignments, 'id')
        },
      };

    case types.ASSIGNMENTS_LOAD_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.error
      };

    default:
      return state;
  }
}

export default assignments;
